import { useEffect, useRef, useState } from 'react';

export const useComponentVisible = <T extends HTMLElement>(
  initialIsVisible: boolean,
) => {
  const [isVisible, setIsVisible] = useState(initialIsVisible);
  const ref = useRef<T | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (!ref.current) return;
      if (event.target instanceof Node && !ref.current.contains(event.target)) {
        setIsVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return { ref, isVisible, setIsVisible };
};
